<template>
  <drawer ref="drawer" navbar-disable direction="right">
    <div class="flex justify-between items-center mb-4">
      <button type="button" class="header__link header__link--primary" @click.prevent="close" aria-label="Fechar">
        <i class="icon far fa-chevron-left text-2xl" aria-hidden="true"></i>
      </button>
    </div>

    <div class="datasheet-border">
      <h6 class="details__title">Ficha técnica</h6>
      <slot />
    </div>
  </drawer>
</template>

<script>
import Drawer from 'components/shared/Drawer'

export default {
  components: {
    Drawer
  },

  methods: {
    close() {
      this.$refs.drawer.close()
    },

    open() {
      this.$refs.drawer.open()
    },
  }
}
</script>

<style lang="scss" scoped>
.datasheet-border {
  border: 1px solid #8F8F8F;
  border-radius: 0.25rem;
  @apply px-4;
  @apply py-5;
}
</style>
